import api from './api';

export function postApSecure(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/seguroap/seguro/${data.idCredito}`, data)
}

export function omitApSecure(data) {
  api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${data.idCredito}/state/EN_REGISTRO_REFERENCIAS`, data)
}
